export default __webpack_public_path__ + "static/media/correspondent19.bef32dc8.png";